import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
  CSidebarHeader,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

import { logoNegative } from 'src/assets/brand/logo-negative'
import { sygnet } from 'src/assets/brand/sygnet'
import { useAuth } from '../views/authentication/auth'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'
import navigationSales from '../_navSales.js'
import navigationLeader from '../_navLeader.js'
import navigationAccount from '../_navAccount.js'
import navigationSuper from '../_navSuper.js'
import { getUserPermissions, filterNavigationByPermissions } from '../permissionHelper'

const AppSidebar = () => {
  const auth = useAuth()
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const role = localStorage.getItem('role')
  const username = localStorage.getItem('user')
  // Get user permissions
  const userPermissions = React.useMemo(() => getUserPermissions(), [])
  const filteredNavigation = React.useMemo(() => {
    let navItems = navigation

    // Select navigation based on role (keep existing logic)
    if (role === 'SALES') {
      navItems = navigationSales
    } else if (role === 'ADMIN') {
      navItems = navigation
    } else if (role === 'LEADER') {
      navItems = navigationLeader
    } else if (role === 'ACCOUNT') {
      navItems = navigationAccount
    } else if (role === 'SUPER') {
      navItems = navigation
    }

    // Filter by permissions
    return filterNavigationByPermissions(navItems, userPermissions)
  }, [role, userPermissions])
  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} />
        <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
      </CSidebarBrand>

      <CSidebarHeader>
        <div className="info-bar">
          <p>Welcome, {username}</p>
        </div>
      </CSidebarHeader>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={filteredNavigation} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
